import React from 'react'
import ReactDOM from 'react-dom/client'
/*import { StagewiseToolbar } from '@stagewise/toolbar-react'
import { ReactPlugin } from '@stagewise-plugins/react' */
import App from './App.tsx'
import './index.css'

// 渲染主应用
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    {/*
    // Stagewise 0.4.8版本集成 - 只在开发模式下
    {process.env.NODE_ENV !== 'production' && (
      <StagewiseToolbar config={{ plugins: [ReactPlugin] }} />
    )}
    */}
  </React.StrictMode>,
)

 
